import { STATUS_TYPES_CLASSNAMES } from 'components/Status/constants'
import { DISPUTE_STATUSES } from './Rebates/RebatesTable/InvoicesDetailsPopup/InvoicesDetails/InvoicesTable/types'

export const FINANCIAL_TABS = [
  {
    key: '0',
    label: 'Rebates'
  },
  {
    key: '1',
    label: 'Admin'
  },
  {
    key: '2',
    label: 'Marketplace AR'
  },
  {
    key: '3',
    label: 'Split fees'
  }
]

export const REPORTS_COLORS = {
  disputed: 'light_red',
  waiting_for_response: 'blue',
  payment_in_progress: 'gray',
  paid: 'green',
  partially_paid: 'yellow',
  payment_failed: 'red',
  past_due: 'orange'
} as const

export const FINANCIAL_STATUS_FILTER = [
  {
    label: 'Paid',
    value: 'paid',
    index: 0
  },
  {
    label: 'Partially paid',
    value: 'partially_paid',
    index: 1
  },
  {
    label: 'Waiting for response',
    value: 'waiting_for_response',
    index: 2
  },
  {
    label: 'Payment in progress',
    value: 'payment_in_progress',
    index: 3
  },
  {
    label: 'Payment failed',
    value: 'payment_failed',
    index: 4
  },
  {
    label: 'Disputed',
    value: 'disputed',
    index: 5
  },
  {
    label: 'Past due',
    value: 'past_due',
    index: 6
  }
]

export const FINANCIAL_STATUS_LABEL = {
  disputed: 'Disputed',
  paid: 'Paid',
  partially_paid: 'Partially paid',
  payment_failed: 'Payment failed',
  payment_in_progress: 'Payment in progress',
  past_due: 'Past due',
  waiting_for_response: 'Waiting for response'
}

export const INITIAL_DATA_REPORTS_LEGEND = [
  {
    status: 'paid',
    amount: 0,
    percentage: '0'
  },
  {
    status: 'waiting_for_response',
    amount: 0,
    percentage: '0'
  },
  {
    status: 'payment_in_progress',
    amount: 0,
    percentage: '0'
  },
  {
    status: 'payment_failed',
    amount: 0,
    percentage: '0'
  },
  {
    status: 'disputed',
    amount: 0,
    percentage: '0'
  },
  {
    status: 'past_due',
    amount: 0,
    percentage: '0'
  }
]

export const INITIAL_DATA_REPORTS_LEGEND_WITH_PARTIAL = [
  {
    status: 'paid',
    amount: 0,
    percentage: '0'
  },
  {
    status: 'partially_paid',
    amount: 0,
    percentage: '0'
  },
  ...INITIAL_DATA_REPORTS_LEGEND.slice(1)
]

export const DISPUTE_STATUS_TO_CLASSNAME = {
  [DISPUTE_STATUSES.DEFERRED]: STATUS_TYPES_CLASSNAMES.LIGHTRED,
  [DISPUTE_STATUSES.EXCLUDED]: STATUS_TYPES_CLASSNAMES.LIGHTBLUE
}

export const DISPUTE_STATUS_NAME = {
  [DISPUTE_STATUSES.DEFERRED]: 'Deferred',
  [DISPUTE_STATUSES.EXCLUDED]: 'Excluded'
}
